import { Box, Typography } from '@mui/material';
import { useFormContext, useWatch } from 'react-hook-form';
import { RevealView, StaggerItemView, StaggerView } from '../../common/motion';
import IntroPortalFeatureCard from './IntroPortalFeatureCard';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var IntroPortalSection = function IntroPortalSection() {
  /**
   * watch
   */
  var _useFormContext = useFormContext(),
      control = _useFormContext.control;

  var portalTitle = useWatch({
    control: control,
    name: 'portalTitle'
  });
  var portalFeatures = useWatch({
    control: control,
    name: 'portalFeatures'
  });
  return /*#__PURE__*/_jsxs(Box, {
    className: "flex w-full flex-col items-center space-y-14 py-16 md:py-24",
    children: [/*#__PURE__*/_jsx(RevealView, {
      className: "text-center",
      children: /*#__PURE__*/_jsx(Typography, {
        component: "h2",
        className: "font-['Playfair_Display',serif] text-3xl font-black leading-tight text-[#202020] md:text-[38px]",
        children: portalTitle
      })
    }), /*#__PURE__*/_jsx(StaggerView, {
      className: "grid w-full grid-cols-1 gap-10 md:grid-cols-3",
      stagger: 0.12,
      children: portalFeatures.map(function (item) {
        return /*#__PURE__*/_jsx(StaggerItemView, {
          distance: 28,
          children: /*#__PURE__*/_jsx(IntroPortalFeatureCard, {
            item: item
          })
        }, item.title);
      })
    })]
  });
};

export default IntroPortalSection;